// Categorical series colours for mgPris charts. Light values are the ones used before dark mode.
export type ChartSeriesName =
  | 'blue'
  | 'orange'
  | 'aqua'
  | 'yellow'
  | 'magenta'
  | 'green'
  | 'violet'
  | 'red';

export interface ChartPalette {
  series: Record<ChartSeriesName, string>;
}

// Order in which series colours are assigned in multi-series charts.
export const chartSeriesOrder: readonly ChartSeriesName[] = [
  'blue',
  'orange',
  'aqua',
  'yellow',
  'magenta',
  'green',
  'violet',
  'red',
];

export const chartLight: ChartPalette = {
  series: {
    blue: '#2A78D6',
    orange: '#EB6834',
    aqua: '#1BAF7A',
    yellow: '#EDA100',
    magenta: '#E87BA4',
    green: '#008300',
    violet: '#4A3AA7',
    red: '#E34948',
  },
};

export const chartDark: ChartPalette = {
  series: {
    blue: '#3987E5',
    orange: '#D95926',
    aqua: '#199E70',
    yellow: '#C98500',
    magenta: '#D55181',
    green: '#2E9E42',
    violet: '#9085E9',
    red: '#E66767',
  },
};
